<template>
  <div class="container">
    <div class="btn-back" @click="handleBack">返回</div>
    <div class="row1">
      <div class="area-title mg-bottom">
        <span>设定端口</span>
      </div>
      <!--  -->
      <div class="gauge-box">
        <div><gaugeLeft ref="gauLeft" :souceData="souceDataLeft"></gaugeLeft></div>
        <div><gagueRight ref="gauRight" :souceData="souceDataRight"></gagueRight></div>
      </div>
    </div>

    <!-- 第二行 -->
    <div class="row2">
      <barEcharts ref="barEcharts" :rateList="rateList" :vData="vData" :ySerise="ySerise"></barEcharts>
    </div>
  </div>
</template>
<script>
import gaugeLeft from'./gauge-chart/gauge-left.vue';
import gagueRight from './gauge-chart/gauge-right.vue';
import barEcharts from './bar-echart/index.vue'
export default {
  data() {
    return {
      echartArea: null,
      distributionPort:200,
      portSum:1000,
      souceDataLeft:null,
      souceDataRight:null,
      rateList:[],
      vData:[],
      ySerise:[]
    };
  },
  props:{
    level:'',
    regionId:''
  },
  components:{
    gaugeLeft,
    gagueRight,
    barEcharts
  },
  mounted() {
    this.getSouceData();
  },
  methods: {
    handleBack(){
      this.$router.push({
        path:'/home'
      })
    },
    getSouceData(){
      this.$http({
        url: this.$http.adornUrl("/admin/api/busi/ev/stat/socket"),
        method: "get",
        params: this.$http.adornParams({
          deviceType: 1,
          level:this.level,
          regionId: this.regionId,
        }),
      }).then(({ data }) => {
        console.log(data,'设定端口数')
        if (data.code == 0) {
          this.souceDataLeft = data.data.lowEvSocketType
          this.souceDataRight = data.data.highEvSocketType
          this.ySerise = data.data.evtypeNameList;
          this.vData = data.data.evtypeNumList;
          this.rateList = data.data.evTypeRateList;
          this.$nextTick(()=>{
            this.$refs.gauLeft.updatedChart()
            this.$refs.gauRight.updatedChart()
            this.$refs.barEcharts.updatedChart()
          })
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container{
  width: 100%;
  height: 472px;
  position: relative;
  .btn-back{
    width: 115px;
    height: 35px;
    text-align: center;
    line-height: 35px;
    letter-spacing: 6px;
    background: rgba(0,53,178,0.3);
    box-shadow: 0px 0px 3px 0px rgba(0,150,255,0.6);
    border-radius: 20px;
    border: 1px solid #5284E0;
    position: absolute;
    right: 10px;
    top:-30px
  }
}
.row1 {
  width: 100%;
  height: 210px;
  .gauge-box{
    display: grid;
    grid-template-columns:50% 50%;
  }
}
.row2{
  width: 100%;
  height: 262px;
  // background: #f0f;
}
.row-flex{
  display: flex;
  justify-content: space-between;
  .img-box{
    width: 50px;
    height: 50px;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.left-flex,.right-flex{
  display: flex;
  .word-box{
    margin-left: 10px;
  }
}
.area-title {
  width: 284px;
  height: 32px;
  background: url("../../assets/pgzl-ranking-bg.png");
  background-size: cover;
  background-position: center center;
  color: #fff;
  font-size: 14px;
  line-height: 32px;
  span {
    margin-left: 40px;
  }
}
.mg-bottom {
  // margin-bottom: 10px;
}
.area-bg {
  width: 100%;
  height: 185px;
  background-image: url("../../assets/pagoda-bg.png");
  background-size: 100% 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/car-system/option3.vue